import { render } from "./Example3.vue?vue&type=template&id=0c9cd9df&ts=true"
import script from "./Example3.vue?vue&type=script&lang=ts"
export * from "./Example3.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__